import { createClient, createMicrophoneAndCameraTracks } from "agora-rtc-react";
const appId = "c0db6b8b5a4044f58da44632d69768a1";

export const config = { mode: "rtc", codec: "vp8", appId: appId };

export const useClient = createClient(config);
export const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks();
